import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export interface HighlightBoxProps {
  children: React.ReactNode;
  variant?: 'default' | 'warning' | 'important';
}

const HighlightContainer = styled.div<{ $variant: 'default' | 'warning' | 'important' }>`
  padding: 15px;
  border-left: 4px solid;
  margin: 20px 0;
  border-radius: 0 5px 5px 0;
  
  ${({ $variant }) => {
    switch ($variant) {
      case 'warning':
        return `
          background: #fff3cd;
          border-left-color: ${theme.colors.warning};
        `;
      case 'important':
        return `
          background: #d1ecf1;
          border-left-color: ${theme.colors.info};
        `;
      default:
        return `
          background: #f8f9fa;
          border-left-color: #667eea;
        `;
    }
  }}

  h3 {
    color: #2c3e50;
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 1.2em;
  }

  p {
    margin-bottom: 10px;
    text-align: justify;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const HighlightBox: React.FC<HighlightBoxProps> = ({ 
  children, 
  variant = 'default' 
}) => {
  return (
    <HighlightContainer $variant={variant}>
      {children}
    </HighlightContainer>
  );
};

